/*LIBRARY*/
import { useState, useRef } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import {
  set_value_insight,
  insight_search_admin,
  insight_hirarki_admin,
} from "../../App/actions/insight_v2";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

const AREA_SEARCH = ({
  auth,
  insight_reducer,
  set_value_insight,
  insight_search_admin,
  insight_hirarki_admin,
}) => {
  const [state, setState] = useState({
    text_input: "",
    typing_status: false,
    kota_list_filtered: [],
    kecamatan_list_filtered: [],
    kelurahan_list_filtered: [],
    level: "",
  });

  const timer = useRef(null);

  const on_click_adm = (object_adm, level) => {
    setState((prevState) => ({ ...prevState, typing_status: false, level }));

    const PROVINSI = object_adm?.["PROVINSI"];
    const KABKOT = object_adm?.["KABKOT"];
    const KECAMATAN = object_adm?.["KECAMATAN"];
    const DESA = object_adm?.["DESA"];

    if (level === "kota") {
      set_value_insight({
        key: "provinsi",
        value: PROVINSI,
      });
      set_value_insight({
        key: "kota",
        value: KABKOT,
      });
      set_value_insight({
        key: "kecamatan",
        value: "",
      });
      set_value_insight({
        key: "kelurahan",
        value: "",
      });

      //get hirarki provinsi
      insight_hirarki_admin({
        ...object_adm,
        level: "provinsi",
      });
      //get hirarki kota
      insight_hirarki_admin({
        ...object_adm,
        level: "kota",
      });
      //get hirarki kecamatan
      insight_hirarki_admin({
        ...object_adm,
        level: "kecamatan",
      });
    } else if (level === "kecamatan") {
      set_value_insight({
        key: "provinsi",
        value: PROVINSI,
      });
      set_value_insight({
        key: "kota",
        value: KABKOT,
      });
      set_value_insight({
        key: "kecamatan",
        value: KECAMATAN,
      });
      set_value_insight({
        key: "kelurahan",
        value: "",
      });

      //get hirarki provinsi
      insight_hirarki_admin({
        ...object_adm,
        level: "provinsi",
      });
      //get hirarki kota
      insight_hirarki_admin({
        ...object_adm,
        level: "kota",
      });
      //get hirarki kecamatan
      insight_hirarki_admin({
        ...object_adm,
        level: "kecamatan",
      });
      //get hirarki kelurahan
      insight_hirarki_admin({
        ...object_adm,
        level: "kelurahan",
      });
    } else if (level === "kelurahan") {
      set_value_insight({
        key: "provinsi",
        value: PROVINSI,
      });
      set_value_insight({
        key: "kota",
        value: KABKOT,
      });
      set_value_insight({
        key: "kecamatan",
        value: KECAMATAN,
      });
      set_value_insight({
        key: "kelurahan",
        value: DESA,
      });

      //get hirarki provinsi
      insight_hirarki_admin({
        ...object_adm,
        level: "provinsi",
      });
      //get hirarki kota
      insight_hirarki_admin({
        ...object_adm,
        level: "kota",
      });
      //get hirarki kecamatan
      insight_hirarki_admin({
        ...object_adm,
        level: "kecamatan",
      });
      //get hirarki kelurahan
      insight_hirarki_admin({
        ...object_adm,
        level: "kelurahan",
      });
    }
  };

  const on_change_single_input = (e) => {
    e.preventDefault();
    clearTimeout(timer.current);
    setState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
      typing_status: true,
    }));
    if (!e.target.value) {
      setState((prevState) => ({
        ...prevState,
        kota_list_filtered: [],
        kecamatan_list_filtered: [],
        kelurahan_list_filtered: [],
        typing_status: false,
      }));
    }
    timer.current = setTimeout(trigger_action, WAIT_INTERVAL);
  };

  const handle_key_down = (e) => {
    if (e.keyCode === ENTER_KEY) {
      trigger_action();
    }
  };

  const trigger_action = () => {
    try {
      const { text_input } = state;
      if (text_input.length > 3) {
        const params = {
          search: text_input,
        };
        insight_search_admin(params);
      }
    } catch (error) {}
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  const { level, text_input, typing_status } = state;

  //global props
  const {
    kelurahan_list_by_search,
    kecamatan_list_by_search,
    kota_list_by_search,
    provinsi,
    kota,
    kecamatan,
    kelurahan,
  } = insight_reducer;

  //content
  return (
    <main>
      <p className="text_medium sub_color margin_bottom">
        {dict?.["Type City or Village Name"]?.[language]}
      </p>
      <input
        className="margin_bottom"
        type="text"
        placeholder={
          dict?.["For example: Bandung, Tebet, Sukamenak"]?.[language]
        }
        autoComplete="off"
        name="text_input"
        value={text_input}
        onChange={on_change_single_input}
        onKeyDown={handle_key_down}
        data-mapid="insertWilayah"
      />
      {typing_status && (
        <section
          className="container text_medium sub_color"
          style={{ overflowY: "scroll", maxHeight: "300px" }}
        >
          {kota_list_by_search.map((item, idx) => {
            return (
              <div
                key={idx}
                className="cursor_pointer"
                onClick={() => on_click_adm(item, "kota")}
              >
                {item?.["KABKOT"]}{" "}
                <span className="badge_small blue_container">
                  {item?.["KABKOT"]?.includes("KOTA ") ? "KOTA" : "KAB"}
                </span>
                <hr />
              </div>
            );
          })}
          {kecamatan_list_by_search.map((item, idx) => {
            return (
              <div
                key={idx}
                className="cursor_pointer"
                onClick={() => on_click_adm(item, "kecamatan")}
                data-mapid={`clickWilayah-${idx}`}
              >
                {item?.["KECAMATAN"]}, {item?.["KABKOT"]}{" "}
                <span className="badge_small blue_container">KEC</span>
                <hr />
              </div>
            );
          })}
          {kelurahan_list_by_search.map((item, idx) => {
            return (
              <div
                key={idx}
                className="cursor_pointer"
                onClick={() => on_click_adm(item, "kelurahan")}
              >
                {item?.["DESA"]}, {item?.["KECAMATAN"]}, {item?.["KABKOT"]}{" "}
                <span className="badge_small blue_container">DESA</span> <hr />
              </div>
            );
          })}
        </section>
      )}
      {level && (
        <section className="container background_grey_light sub_color margin_top text_small">
          {level === "provinsi" ? (
            <>
              {provinsi}{" "}
              <span className="badge_small blue_container">PROV</span>
            </>
          ) : level === "kota" ? (
            <>
              {kota}{" "}
              <span className="badge_small blue_container">
                {kota?.includes("KOTA ") ? "KOTA" : "KAB"}
              </span>
              , {provinsi}{" "}
              <span className="badge_small blue_container">PROV</span>
            </>
          ) : level === "kecamatan" ? (
            <>
              {kecamatan}{" "}
              <span className="badge_small blue_container">KEC</span>, {kota}{" "}
              <span className="badge_small blue_container">
                {kota?.includes("KOTA ") ? "KOTA" : "KAB"}
              </span>
              , {provinsi}{" "}
              <span className="badge_small blue_container">PROV</span>
            </>
          ) : level === "kelurahan" ? (
            <>
              {kelurahan}{" "}
              <span className="badge_small blue_container">KEL</span>,{" "}
              {kecamatan}{" "}
              <span className="badge_small blue_container">KEC</span>, {kota}{" "}
              <span className="badge_small blue_container">
                {kota?.includes("KOTA ") ? "KOTA" : "KAB"}
              </span>
              , {provinsi}{" "}
              <span className="badge_small blue_container">PROV</span>
            </>
          ) : (
            <></>
          )}
        </section>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  map: state.map,
  properties: state.properties,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {
  set_value_insight,
  insight_search_admin,
  insight_hirarki_admin,
})(AREA_SEARCH);
